import React, { Fragment, useState, useContext } from 'react'
import { UrlServicesContext } from 'components/UrlServicesContext'
import { Redirect } from 'react-router-dom'

import { makeStyles, withStyles } from '@material-ui/core/styles'
import {
  Grid,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Snackbar,
  Slide,
  FormControl,
  TextField,
} from '@material-ui/core'
import axios from 'axios'
import Alert from '@material-ui/lab/Alert'
import { Cancel } from '@material-ui/icons'

import { cardBodyStyle } from 'assets/jss/material-dashboard-react/components/cardBodyStyle'

const useStyles = makeStyles(cardBodyStyle)

const MuiDialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(DialogContent)

const MuiDialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(DialogActions)

export default function NewJob(props) {
  const classes = useStyles()

  const [openAlert, setOpenAlert] = useState(false)
  const [mensaje, setMensaje] = useState('')
  const [error, setError] = useState('')
  const [openAlertSuccess, setopenAlertSuccess] = useState(false)
  const [mensaje_success, setmensaje_success] = useState('')
  const [returnLogin, setReturnLogin] = React.useState(false)

  let keyAuthorization = localStorage.getItem('Session')

  const { urlServices, keyAplication } = useContext(UrlServicesContext)

  const [values, setValues] = useState({
    name: '',
    errorName: false,
  })

  const handleCloseDialog = (pro) => (event) => {
    props.exit()
  }

  const handleChange = (prop) => (event) => {
    setopenAlertSuccess(false)

    setValues({
      ...values,
      [prop]: event.target.value,
      errorName: false,
    })
    setOpenAlert(false)
  }

  const submitForm = async (e) => {
    e.preventDefault()
    setError('')
    setopenAlertSuccess(false)

    // Validación del campo nombre
    if (!values.name.trim()) {
      setValues((prev) => ({ ...prev, errorName: true }))
      setMensaje('El campo "Nombre" es obligatorio.')
      setOpenAlert(true)
      setError('error')
      return // Salir temprano si hay error
    }

    const dataValue = {
      name: values.name.trim(), // Limpiar espacios en blanco
      userId: localStorage.getItem('id'),
    }

    try {
      await axios.post(`${urlServices}jobs`, dataValue, {
        headers: {
          application: keyAplication,
          Authorization: `Bearer ${keyAuthorization}`,
        },
      })

      // Manejo de éxito
      setopenAlertSuccess(true)
      setmensaje_success('Registro guardado con éxito.')
      props.callBackRefresh()

      // Resetear formulario manteniendo otros valores
      setValues((prev) => ({ ...prev, name: '' }))
    } catch (e) {
      if (e.response.status === 401) {
        setTimeout(() => {
          localStorage.clear()
          setReturnLogin(true)
        }, 200)
      } else if (e.response.status === 409) {
        setMensaje(
          'Por favor ingresar otro nombre de cargo, ya tenemos registrado en nuestra base de datos este nombre.'
        )
        setOpenAlert(true)
        setError('error')
      } else {
        setMensaje('Error de conexión, intente más tarde.')
        setOpenAlert(true)
        setError('error')
      }
    }
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpenAlert(false)
  }

  if (returnLogin) {
    return <Redirect to="/" />
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        style={{ zIndex: 100 }}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <MuiDialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={2} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                <div className={classes.titleCardFilter}>Nuevo cargo</div>
                <div className={classes.lineBottom}></div>
                <br></br>
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    name="name"
                    value={values.name}
                    error={values.errorName}
                    onChange={handleChange('name')}
                    fullWidth
                    required
                    label="Nombre"
                    margin="dense"
                    autoComplete="off"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12}>
                <br></br>
                <br></br>
                <center>
                  <Button
                    type="submit"
                    className={classes.buttonSubmit}
                    onClick={submitForm}
                  >
                    Guardar
                  </Button>
                </center>
              </Grid>
              <Grid item xs={12} sm={12}>
                <center>
                  {openAlertSuccess && (
                    <Alert severity="success">{mensaje_success}</Alert>
                  )}
                </center>
              </Grid>
            </Grid>
            <Snackbar
              open={openAlert}
              autoHideDuration={8000}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              onClose={handleClose}
            >
              <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
                <Alert
                  onClose={handleClose}
                  severity={error === 'error' ? 'error' : 'success'}
                  elevation={6}
                  variant="filled"
                >
                  {mensaje}
                </Alert>
              </Slide>
            </Snackbar>
          </Fragment>
        </MuiDialogContent>
        <MuiDialogActions>
          <Button onClick={handleCloseDialog(true)}>
            <Cancel />
          </Button>
        </MuiDialogActions>
      </Dialog>
    </Fragment>
  )
}
